export const loadingStates = {
  loading: 'loading',
  failed: 'failed',
  success: 'success',
};

export const modalStates = {
  closed: 'closed',
  openReprocess: 'openReprocess',
  openDelete: 'openDelete',
};
